import { Link } from "react-router-dom";
import Icon from "@/components/icons/Icon.jsx";
import "@/components/menu-icons.css";

/**
 * Back navigation with a leading arrow icon.
 * @param {{ to?: string, onClick?: () => void, children: import("react").ReactNode, className?: string }} props
 */
export default function BackLink({ to, onClick, children, className = "" }) {
    const content = (
        <>
            <Icon name="arrow-left" className="back-link__icon" />
            <span>{children}</span>
        </>
    );
    const classes = `back-link muted${className ? ` ${className}` : ""}`;

    if (to) {
        return (
            <Link to={to} className={classes}>
                {content}
            </Link>
        );
    }

    return (
        <button type="button" className={`link-btn ${classes}`} onClick={onClick}>
            {content}
        </button>
    );
}
